import React from 'react';
import { Grid } from "@mui/material";
import cx from 'classnames';
import { Pill } from 'Components';

/**
 * Renders all/entities/tags selection pills
 */
const OptionSelector = ({
    option,
    entity,
    onOptionChange,
    onChange,
    onSearchTextChange,
    entityOptionButtonClass,
    messages
}) => {
    const options = [
        { id: "all", label: messages[`entityUnitDriverSelector_all${entity?.id || ""}`] },
        { id: "entities", label: messages[`entityUnitDriverSelector_single${entity?.id || ""}`] },
        { id: "tags", label: messages['entityUnitDriverSelector_tags'] },
    ];

    const handleOptionClick = (newOption) => {
        if (onOptionChange) onOptionChange(newOption);
        if (onChange) onChange([], entity);
        if (onSearchTextChange) onSearchTextChange("");
    };

    return (
        <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            className={cx("option-selector", entityOptionButtonClass)}
            spacing={1}
        >
            {options.map((newOption, index) => (
                <Grid item xs key={index}>
                    <Pill
                        textField="label"
                        item={newOption}
                        outlined={newOption?.id !== option?.id}
                        onClick={() => handleOptionClick(newOption)}
                        className="option-selector__pill"
                        colorField="default"
                        colorSelection="005bf8"
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default OptionSelector;

